import { HttpClient } from '@angular/common/http';
import { StockService } from './stock.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService, StockItem } from 'src/app/core';

@Injectable({ providedIn: 'root' })
export class BindingsService extends StockService {
  constructor(http: HttpClient, configService: ConfigService) {
    super(http, configService);
  }

  getAll(): Observable<StockItem[]> {
    return this.all();
  }
}
